<template>
  <div class="openClose">
    <div v-if="typeCode != '022'" class="openInfo" :class="{ newClass: isShow }">
      <el-radio-group v-model="value" @change="changeVal">
        <el-radio-button label>不限</el-radio-button>
        <el-radio-button
          v-for="(item, index) in options"
          :key="index + item.codeName"
          :label="item.codeName"
        ></el-radio-button>
      </el-radio-group>
    </div>
    <div v-else class="openInfo" :class="{ newClass: isShow }">
      <el-radio-group v-model="value" @change="changeVal">
        <el-radio-button label>不限</el-radio-button>
        <el-radio-button
          v-for="(item, index) in options"
          :key="index + item.codeName"
          :label="item.codeId + ''"
        >
          {{ item.codeName }}</el-radio-button
        >
      </el-radio-group>
    </div>
  </div>
</template>

<script>
import { codeType } from '@/api/common'
export default {
  props: {
    typeCode: {
      // 查询的字典值
      type: String,
      default: ''
    },
    code: {
      // 选中的那一项的key
      type: String,
      required: true
    },
    queryName: {
      // el-tags做标识
      type: String
    },
    name: {
      // el-tags选中的文字
      type: String
    }
  },
  data() {
    return {
      options: [],
      value: '',
      openSpan: '展开全部',
      openicon: 'el-icon-arrow-down',
      openValue: true,
      isShow: false
    }
  },
  watch: {
    code: function (newVal) {
      this.value = newVal
    },
    value: function (newVal) {
      this.$emit('update:code', newVal)
    }
  },
  created() {
    this.getDicData()
  },
  methods: {
    async getDicData() {
      this.options = sessionStorage.getItem(this.typeCode)
      if (!this.options) {
        const { data: res } = await codeType({ code: this.typeCode })
        sessionStorage.setItem(this.typeCode, JSON.stringify(res.data))
      }
      this.options = JSON.parse(sessionStorage.getItem(this.typeCode))
      //删除 项目中心-优先级 label
      let excludeValue = this.options[this.options.length - 1]
      if (excludeValue.codeName == '冻结' && excludeValue.codeType == '009') {
        this.options.pop()
      }
      if (this.code) {
        this.options.forEach((item) => {
          if (item.codeName === this.code) {
            this.value = item.codeName
          }
        })
      }
    },
    // 标签打开
    openItem() {
      if (this.openValue) {
        this.isShow = true
        // this.openSpan = '点击关闭'
        this.openicon = 'el-icon-arrow-up'
        this.openValue = false
      } else {
        this.isShow = false
        // this.openSpan = '点击展开'
        this.openValue = true
        this.openicon = 'el-icon-arrow-down'
      }
    },
    changeVal(val) {
      console.log(val)
      this.$emit('onChange', val, this.queryName, this.name)
    }
  }
}
</script>

<style lang="less" scoped>
.openClose {
  display: flex;
  justify-content: space-between;
  .openButton {
    width: 10%;
    line-height: 30px;
    color: #1e9fff;
    cursor: pointer;
    text-align: center;
  }
}
.openInfo {
  width: 90%;
  max-height: 40px;
  overflow: hidden;
  // transition: all 1s linear;
}
.newClass {
  width: 90%;
  max-height: 400px;
  overflow: none;
  transition: all 1s linear;
}
/deep/ .el-radio-button__inner {
  border: 1px solid #fff !important;
  padding: 9px 10px;
}
/deep/ .el-radio-button__inner:hover {
  color: #17757a;
}
/deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background-color: #fff;
  color: #17757a;
  border: 1px solid #17757a !important;
  box-shadow: none;
}
/deep/ .el-radio-button.is-checked .el-radio-button__inner {
  box-shadow: none;
}
</style>
